import React from "react";
import Constants from "app/shared/constants/constants";
import brandHelper from "app/shared/utils/BrandHelper";

const BrandCategoryURL = (): React.ReactElement => {
    let url = "";
    let title = "";
    const {brandName} = brandHelper();

    switch (brandName) {
        case Constants.NOAH_APP:
            url = Constants.NOAH_CATERING_LINK;
            title = "noahscatering.com";
            break;
        case Constants.BRUEGGERS_APP:
            url = Constants.BRU_CATERING_LINK;
            title = "catering.brueggers.com";
            break;
        case Constants.EINSTEIN_APP:
            url = Constants.EBB_CATERING_LINK;
            title = "ebcatering.com";
            break;
        default:
            break;
    }
    return (
        <h6 className="text-center font-sub mb-4">
            <small className="text-muted">
                Please visit
                {' '}
                <a
                    className="text-muted text-decoration-none"
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                >
                    {title}
                </a>
                {' '}
                for orders over $200.00
            </small>
        </h6>

    );
};

export default BrandCategoryURL;
